var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid main-content"},[_c('div',{staticClass:"main-panel"},[_c('div',{staticClass:"content-wrapper"},[_c('router-view',{key:_vm.$route.path,staticClass:"w3-animate-opacity"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }